
import { version } from '~/../package.json';
import browser from 'detect-browser';


// getBrowserDescription :: _ -> String
const getBrowserDescription = () =>
  browser ? `${browser.name} - ${browser.version}` : 'not-detected';


/** @type {(context: { imdHash: string; }) => Promise<string>} */
export async function getSwCacheName (context) {
  if (window.caches) {
    try {
      const keys = await window.caches.keys();
      if (!keys.length) {
        return 'no-serviceworker-installed';
      }
      
      const swVersion = keys.reduceRight((acc, key) => {
        if (acc || !key || !key.includes(context.imdHash)) return acc;
        return key;
      }, null);
      
      return swVersion || `no-sane-cache-of-${keys.length}`;
    } catch (error) {
      console.error(error);
    }
  }
  return noServiceWorkerReason();
}

/** @type {(context: { imdHash: string; }) => Promise<string>} */
export async function getVersionDescription (context) {
  const swVersion = await getSwCacheName(context);
  return `${version}/${swVersion}`;
}

/** 
 * @typedef {Object} Status 
 * @property {number} kioskId
 * @property {boolean} local
 * @property {string} browser
 * @property {string} version
 * @property {string} callback
 */

/** @type {(context: { imdId: number; imdHash: string; }) => Promise<Status>} */
export const getStatus = (context) => {
  return getVersionDescription(context).then(version => ({
    kioskId: context.imdId,
    local: false,
    browser: getBrowserDescription(),
    version,
    callback: 'none'
  }));
};

const noServiceWorkerReason = () => {
  if (location.protocol == 'http:') return 'no-serviceworker-as-http';
  if (!navigator.serviceWorker) return 'no-serviceworker-as-no-api';
  return 'no-serviceworker';
};

